/* istanbul ignore file */
import { Box } from '@mui/material';
import { CreateForm, TextInput } from 'framework/form';
import { usePrivilegedEmployeeId } from '../../privilegedAccessRouting';
import { PositionDropdown, useEmployeeUrl, EmployeeTypeDropdown, useEmployeeService } from 'domain/shared/employee';
import { useExternalAccountsService } from '../externalAccountsService';
import { InputTooltip, CreatePageLayout, FormSection, FormRow } from 'framework/ui/layout';
import useDeprovisionResponseHandler from './accountsDeprovisionResponseHandler';

const EmployeeAccountsCreationForm = () => {
  const employeeAlias = usePrivilegedEmployeeId();
  const { getById } = useEmployeeService();
  const { getProfileEditUrl } = useEmployeeUrl();
  const { deprovisionExternalAccounts } = useExternalAccountsService();
  const { handleDeprovisionResponse } = useDeprovisionResponseHandler();

  const submitFormFunc = async () => {
    const response = await deprovisionExternalAccounts({ employeeId: employeeAlias });
    handleDeprovisionResponse(response);
  };

  return (
    <CreateForm
      getDataFunc={() => getById(employeeAlias)}
      submitFormFunc={submitFormFunc}
      afterSubmit={{
        execute: () => {},
      }}
    >
      <CreatePageLayout title="Deprovision: Azure, Redmine and GitLab accounts">
        <FormSection title="Worker account information">
          <FormRow>
            <TextInput label="First name" source="nameEn.firstName" disabled />
            <TextInput label="Last name" source="nameEn.lastName" disabled />
          </FormRow>
          <FormRow>
            <EmployeeTypeDropdown label="Type" source="employeeType" disabled />
            <PositionDropdown label="Position" source="positionId" disabled isRequired />
          </FormRow>
          <FormRow>
            <TextInput label="Syberry email" source="workingEmail" disabled />
            <TextInput label="Azure ID" source="azureId" disabled />
          </FormRow>
          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
            <a href={getProfileEditUrl(employeeAlias)} target="_blank" rel="noreferrer">
              Open worker profile
            </a>
            <InputTooltip
              message="Reload page to get profile changes"
              source=""
              size="small"
              sx={{ marginLeft: '10px' }}
            />
          </Box>
        </FormSection>
      </CreatePageLayout>
    </CreateForm>
  );
};

export default EmployeeAccountsCreationForm;
